// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"142":"b207d5d2","335":"26dba7c1","374":"25a3ba84","380":"ab373cd6","431":"43095b93","590":"1d26f463","684":"15c9b1a6","744":"12ccc13c","782":"7f0ad48a","963":"646241b8"}[chunkId] + ".js";
};